import { render, staticRenderFns } from "./PageMain.vue?vue&type=template&id=7c6161d4&scoped=true&"
import script from "./PageMain.vue?vue&type=script&lang=js&"
export * from "./PageMain.vue?vue&type=script&lang=js&"
import style0 from "./PageMain.vue?vue&type=style&index=0&id=7c6161d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6161d4",
  null
  
)

export default component.exports